import type { DirectionBrief, InvestigationLabels } from '@/frontend/features/Fde/investigations/types'

export default function DirectionDimension({ brief, copy, detailed = false }: { brief?: DirectionBrief | null; copy: InvestigationLabels; detailed?: boolean }) {
  const dimension = brief?.dimension
  // Keep exact large-number strings; the browser never estimates money,
  // impact, or a percentage from a scout's selected population.
  const value = typeof dimension?.value === 'number' ? dimension.value.toLocaleString('pt-BR') : dimension?.value
  return <div className="grid min-w-0 gap-1">
    {dimension ? <>
      <p className="text-sm font-medium tabular-nums">{value} {dimension.unit}</p>
      <p className="text-xs leading-relaxed text-muted-foreground">{dimension.label}</p>
      {detailed && <p className="mt-1 text-xs leading-relaxed text-muted-foreground">{dimension.context}</p>}
    </> : <p className="text-xs text-muted-foreground">{copy.dimension_unknown}</p>}
    {detailed && <p className="text-xs leading-relaxed text-muted-foreground">{dimension ? copy.dimension_not_gain : copy.dimension_unknown_hint}</p>}
  </div>
}
